import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { getDataQuicksBookLogAsync, resetSelectedRecordObjectInState, setDateRangeValue, setIsRemoveFilterSetting, setStatusValue, setQBEventValue } from '../../accountQBOnline/accountQBLog/QuicksBookLogSlice';
import Select, { StylesConfig } from 'react-select';
import moment from 'moment';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat } from '../../../../common/timeLiveFunction';

const QuickBookLogFilter = (props: any) => {
    const { modelRef, t } = props;
    const { sessionAccountEmployeeId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector(state => state.globalState);
    const { quikBookLogList, isReload, selectedRecord, isLoading, startDate, endDate, currentPage, pageSize, start, columnIndex, direction } = useAppSelector((state) => state.quicksBookLog);
    const dispatch = useAppDispatch();
    const currentDate = new Date();
    const [SelectedStartDate, setSelectedStartDate] = useState(() => {
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        return newDate;
    });
    const [SelectedEndDate, setSelectedEndDate] = useState(currentDate);
    const [selectedOptionStatus, setSelectedOptionStatus] = useState({ label: 'All', value: 'All' });
    const [selectedOptionEventType, setSelectedOptionEventType] = useState({ label: 'All', value: 'All' });
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const options = [
        { label: 'All', value: 'All' },
        { label: 'Success', value: 'Success' },
        { label: 'Fail', value: 'Fail' }
    ]

    const Eventoptions = [
        { label: 'All', value: "All" },
        { label: 'Import', value: 'D436CD9C-ADFE-4403-B67D-D3A3AB3DEA66' },
        { label: 'Export', value: 'ECB8719D-0115-4E97-837A-933794232A14' }
    ]

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const handleSubmit = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        const StartDate = moment(startDate).format('MM-DD-YYYY');
        const EndDate = moment(endDate).format('MM-DD-YYYY');
        const ActionStatus = selectedOptionStatus?.value
        const QBEvent = selectedOptionEventType?.value
        let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: StartDate, EndDate: EndDate, ActionStatus: ActionStatus, QBEvent: QBEvent };

        dispatch(getDataQuicksBookLogAsync(SearchParamsValues))
            .unwrap()
            .then((originalPromiseResult) => {
                dispatch(setIsRemoveFilterSetting(false));

            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const handleChangeStatus = (selectedOption: any) => {
        setSelectedOptionStatus(selectedOption);
    }

    const handleChangeEvent = (selectedOption: any) => {
        setSelectedOptionEventType(selectedOption);
    }

    const handleDateRangeChange = (value: any) => {
        // setSelectedStartDate(value[0]);
        // setSelectedEndDate(value[1]);
        // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }))
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        setSelectedStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
        setSelectedEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
        dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
    }

    const handleResetFiltersOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        const newDate = new Date();
        newDate.setMonth(newDate.getMonth() - 2);
        setSelectedStartDate(newDate);
        setSelectedEndDate(new Date());
        setSelectedOptionStatus({ value: 'All', label: 'All' });
        setStatusValue({ value: 'All', label: 'All' });
        setSelectedOptionEventType({ value: 'All', label: 'All' });
        setQBEventValue({ value: 'All', label: 'All' });
        let SearchParamsValues = { page: currentPage, pageSize: pageSize, start: start, Order: columnIndex, OrderDir: direction, search: " ", StartDate: `${moment(newDate).format(dateInsertionFormat)}`, EndDate: `${moment(new Date()).format(dateInsertionFormat)}`, ActionStatus: 'All', QBEvent: 'All' };
        dispatch(getDataQuicksBookLogAsync(SearchParamsValues));
    }

    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                <div className='col-md-12'>
                    <div className='col-md-12'>
                        <label className="fs-7 fs-7 fw-normal mb-2">{t('Date Range')}</label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                value={[SelectedStartDate, SelectedEndDate]}
                                // placeholder='Please Select Date Range'
                                placeholder={displayedRange}
                                character={' - '}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">{t('Status')}</label>
                        <Select
                            value={selectedOptionStatus}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="StatusId"
                            onChange={handleChangeStatus}
                            options={options}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
                <div className='row spacingBetweenRows'>
                    <div className="col-md-12">
                        <label className="fs-7 fs-7 fw-normal mb-2">{t('QB Event Type')}</label>
                        <Select
                            value={selectedOptionEventType}
                            className="basic-single"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="EventTypeIdId"
                            onChange={handleChangeEvent}
                            options={Eventoptions}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <button
                        type='button'
                        ref={closeButtonRef}
                        style={{ display: 'none' }}
                        id='kt_OffCanvas_close'
                    >
                        {t('Apply Filter')}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm me-2 fs-7"
                        data-kt-element='send'
                        onClick={handleResetFiltersOnClickEvent}
                    >
                        {t('Reset Filters')}
                    </button>
                    <button
                        type="button"
                        data-kt-element='send'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={() => handleSubmit()}
                    >
                        {t('Apply Filters')}
                    </button>
                </div>
            </div>
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default QuickBookLogFilter